import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledFaq = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  position: relative;
  overflow-y: auto;
  padding: ${theme.variables.sidebar_padding};

  & > div:first-child {
    position: absolute;
    top: ${theme.variables.sidebar_padding};
    left: ${theme.variables.sidebar_padding};
  }

  & .content {
    width: 50%;
    min-width: 300px;
    max-width: 700px;
    padding: 10px;
  }

  & .title {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 30px 50px;
  }

  & .faq {
    margin-bottom: 20px;
    padding: 12px;
  }

  & .spinner {
    position: absolute;
    top: 50%;
    left: 50%;
  }

  & .faq-body {
    padding: 24px 0 12px 0;
  }
`;
